import { render, staticRenderFns } from "./Offers.vue?vue&type=template&id=56daff9e&scoped=true&lang=html"
import script from "./Offers.vue?vue&type=script&lang=js"
export * from "./Offers.vue?vue&type=script&lang=js"
import style0 from "./Offers.vue?vue&type=style&index=0&id=56daff9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56daff9e",
  null
  
)

export default component.exports